export var DEFAULT_OVERLAY_TIMEOUT = 150;
export var DEFAULT_OVERLAY_CLASSNAMES = {
    appearActive: "rmd-overlay--active",
    enterActive: "rmd-overlay--active",
    enterDone: "rmd-overlay--active",
};
//# sourceMappingURL=constants.js.map